import { useEffect } from "react";
import { useDispatch } from "react-redux";
import { startGetListadoDocumentando } from "../../../context/actions/ptActions";

export const useGetListadoDocumentado = () => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(startGetListadoDocumentando());
  }, [dispatch]);
};
